import * as tslib_1 from "tslib";
import { Action, Selector, State } from '@ngxs/store';
import { takeUntil, tap } from 'rxjs/operators';
import { FetchEducationalLicenses } from './educational-licenses.actions';
import { Logout } from './auth.actions';
let EducationalLicensesState = class EducationalLicensesState {
    constructor(actions, educationalLicensesRepository) {
        this.actions = actions;
        this.educationalLicensesRepository = educationalLicensesRepository;
    }
    static licenses(state) {
        return state.licenses;
    }
    fetchLicenses(ctx, action) {
        let request = this.educationalLicensesRepository.list()
            .pipe(tap(response => ctx.patchState({
            licenses: response.data.items
        })));
        if (action.cancellationToken) {
            request = request.pipe(takeUntil(action.cancellationToken));
        }
        return request;
    }
    logout(ctx, action) {
        ctx.patchState({
            licenses: [],
        });
    }
};
tslib_1.__decorate([
    Action(FetchEducationalLicenses)
], EducationalLicensesState.prototype, "fetchLicenses", null);
tslib_1.__decorate([
    Action(Logout)
], EducationalLicensesState.prototype, "logout", null);
tslib_1.__decorate([
    Selector()
], EducationalLicensesState, "licenses", null);
EducationalLicensesState = tslib_1.__decorate([
    State({
        name: 'EducationalLicenses',
        defaults: {
            licenses: [],
        }
    })
], EducationalLicensesState);
export { EducationalLicensesState };
